<template>
  <div class="section_top coop_box">
    <el-row :gutter="20" class="top_row">
      <el-col :span="12" align="left">
        <img
          class="md"
          src="@/assets/images/icon_13.png"
          alt=""
        />
        <img
          class="hd"
          src="@/assets/images/icon_13.png"
          alt=""
          style="width: 3px; height: 16px; vertical-align: text-bottom"
        />
        <span>校企合作</span>
      </el-col>
      <el-col
        :span="12"
        class="more hd"
        align="right"
        @click.native="handleClick()"
        ><img src="@/assets/images/phone/sub_more.png" alt=""
      /></el-col>
      <el-col
        :span="12"
        align="right"
        class="desc md"
        @click.native="handleClick()"
        >更多</el-col
      >
    </el-row>

    <div class="imgList hidden-md-and-down">
      <el-row>
        <div class="coop_view_row">
          <el-col
            v-for="(item, index) in imgList"
            :key="index"
            @click.native="handleClickOne(item)"
          >
            <div class="img"><img :src="item.companyImageUrl" alt="" /></div>
          </el-col>
        </div>
      </el-row>
    </div>
    <div class="phone_imgList">
      <el-row class="hidden-lg-and-up" :gutter="20" type="flex" width="auto">
        <el-col
          :md="6"
          :xs="24"
          v-for="(item, index) in imgList"
          :key="index"
          @click.native="handleClickOne(item)"
        >
          <div class="img">
            <img
              :src="item.companyImageUrl"
              alt=""
              style="width: 160px; height: auto"
            />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getCoop } from "@/api/home";
export default {
  name: "homeCoop", //首页-校企合作
  data() {
    return {
      imgList: [],
    };
  },
  mounted() {},
  created() {
    this.handleQuery();
  },
  methods: {
    handleQuery() {
      getCoop()
        .then((res) => {
          const orginalList = res.data.data;
          let repeatList = [];
          //重复列表到30个元素
          while (repeatList.length < 30) {
            repeatList = repeatList.concat(orginalList);
          }

          this.imgList = repeatList.slice(0, 30);

          const viewRowElement = document.querySelector(".coop_view_row");
          if (viewRowElement) {
            viewRowElement.style.width = `${320 * this.imgList.length}px`;
          }
        })
        .catch((err) => {});
    },
    handleClick() {
      const menuName = "合作伙伴";
      this.$store.dispatch("setCommonMoreName", menuName);
      this.$store.commit("SET_ACTIVE_MENU", {
        activeParentMenu: "",
        activeMenu: "合作伙伴",
      });
      this.$router.push({
        path: "/commonMore",
        query: {
          activeParentMenu: "",
          activeMenu: "合作伙伴",
        },
      });
    },
    handleClickOne(item) {
      if (item.clickJumpType === "0") {
        const apiUrl = process.env.VUE_APP_BASE_API + `/web/portal/company/get/one?id=${item.id}`
        const activeMenu = item.companyName
        this.$store.commit("SET_API_URL",apiUrl)
        const payload = {
            activeParentMenu:'合作伙伴',
            activeMenu: activeMenu,
        }
        this.$store.commit("SET_ACTIVE_MENU",payload)
        
        this.$router.push({
            path: '/commonShow',
        })
      } else if (item.clickJumpType === "1") {
        window.open(item.jumpUrl);
      }
    },
  },
};
</script>

<style lang="scss">
.section_top {
  // padding: 15px 26px;
  /* width: 100%; */
  /* height: 241px; */
  // background: #ffffff;
  // border-radius: 10px;
  // box-shadow: 0px 0px 12px 0px rgba(168, 168, 168, 0.46);
}
.top_row img {
  vertical-align: bottom;
  margin-right: 10px;
}
.top_row img:last-child {
  vertical-align: text-top;
  margin-left: 10px;
}
.top_row span {
  font-size: 22px;
  color: #313131;
}
.top_row .more {
  cursor: pointer;
}
.top_row .desc {
  color: #006ff6;
  font-size: 18px;
  text-align: right;
  cursor: pointer;
}
@keyframes slide {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.section_top .imgList {
  padding: 25px;
  padding-left: 0;
  padding-top: 0;
  margin-top: 24px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 0px rgba(168, 168, 168, 0.46);
  text-align: center;
  overflow: hidden;
  .coop_view_row {
    width: calc(100%);
    display: flex;
    .img {
      width: 320px;
      height: 215px;
      float: left;
      margin-left: 22px;
      transform: scale(1);
      transition: transform 0.5s ease;
      cursor: pointer;

      img {
        width: 100%;
      }
      &:hover {
        transform: scale(1.1);
      }
    }
  }
  .coop_view_row {
    animation: slide 120s linear infinite;
    transition: all 0.5s ease;
  }
  .coop_view_row:hover {
    cursor: pointer;
    animation-play-state: paused;
  }
}
.section_top .imgList .el-col {
  height: 100%;
  min-height: 100px;
  max-height: 100%;
}
.section_top .imgList .img {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.section_top .imgList img {
  cursor: pointer;
  margin-right: 62px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.section_top .imgList img:last-child {
  margin-right: 0;
}
.coop_box{
    .top_row{
      .md{
        display: inline-block;
      }
      .hd{
        display: none;
      }
    }
  }
@media (max-width: 1440px) {
  .section_top .imgList {
    box-shadow: none;
    height: auto;
    padding-right: 0;
  }
  .section_top .imgList img {
    width: 100%;
    height: 100%;
  }
  .phone_imgList {
    transition: transform 0.5s ease;
    width: 100%;
    overflow-y: hidden;
    .img {
      width: 160px;
      height: 120px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
      }
    }
  }
  .phone_imgList img {
    transition: transform 0.5s ease;
    margin: 0;
  }
  .phone_imgList {
    padding: 0;
  }
}
@media (max-width: 768px) {
  .top_row span {
    font-size: 16px;
  }
  .section_top .imgList img {
    width: 100%;
    /* height: 95px; */
  }
  .section_top .imgList .img {
    height: 100px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .coop_box{
    .top_row{
      .md{
        display: none;
      }
      .hd{
        display: inline-block;
      }
    }
  }
}
</style>
